import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { generatePath } from '@ps/web-core-utils';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch, useLocation } from 'react-router';

import Redirect from '@swf/components/Redirect/Redirect';
import { select } from '@swf/core/store';

import useCheckHGPath from '../../hooks/useCheckHGPath';
import useFocusGamesList from '../../hooks/useFocusGamesList';
import usePollLobbyData from '../../hooks/usePollLobbyData';
import CashGames from '../CashGames/CashGames';
import useServiceStatusStream from '../Club/Header/CreateGameButtons/hooks/useServiceStatusStream';
import MyClubs from '../MyClubs/MyClubs';
import PublicClubs from '../PublicClubs/PublicClubs';
import Tournaments from '../Tournaments/Tournaments';

import RouteComponent from './RouteComponent';

const Content: React.FC = () => {
  const aliases = useSelector(select.cms.getAliases);
  const cashGamesPath = aliases.homeGamesCashGames ?? '';
  const clubsPath = aliases.homeGamesClubs ?? '';
  const publicClubsPath = aliases.homeGamesPublicClubs ?? '';
  const tournamentsPath = aliases.homeGamesTournaments ?? '';
  const isPublicClubsEnabled = useFeature(FeatureFlag.PKRHomeGamesPublicClubSearch);
  const isEmbedded = useSelector(select.device.isEmbedded);
  const isMobileEmbedded = useSelector(select.device.isMobileEmbedded);
  const shouldAddPublicClubs = isPublicClubsEnabled && !isMobileEmbedded;

  const { pathname } = useLocation();
  const isMainPage = [cashGamesPath, clubsPath, tournamentsPath]
    .map((key) => generatePath(key, {}))
    .includes(pathname);
  const isInHomeGames = useCheckHGPath();

  usePollLobbyData();
  useFocusGamesList();
  useServiceStatusStream();

  useEffect(() => {
    if (isEmbedded && isMainPage) {
      window?.starsweb?.homegames?.menuItemsVisibility?.('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <Switch>
      <Route
        path={cashGamesPath}
        render={() => (
          <RouteComponent>
            <CashGames />
          </RouteComponent>
        )}
      />
      <Route
        path={tournamentsPath}
        render={() => (
          <RouteComponent>
            <Tournaments />
          </RouteComponent>
        )}
      />
      <Route
        path={clubsPath}
        render={() => (
          <RouteComponent>
            <MyClubs />
          </RouteComponent>
        )}
      />
      {shouldAddPublicClubs && (
        <Route
          path={publicClubsPath}
          render={() => (
            <RouteComponent>
              <PublicClubs />
            </RouteComponent>
          )}
        />
      )}
      {isInHomeGames && <Redirect alias="homeGamesClubs" />}
    </Switch>
  );
};

export default Content;
